import React from 'react';
import { useContent } from '../../hooks/useContent';

export const BenefitsSection: React.FC = () => {
  const { content } = useContent();
  
  if (!content?.benefits) return null;

  const colorMap: { [key: string]: string } = {
    'cost-reduction': 'text-teal-400',
    'delivery-speed': 'text-sky-500',
    'value-focus': 'text-yellow-400',
    'zero-bureaucracy': 'text-green-400'
  };

  return (
    <section className="py-20 bg-slate-900">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4 text-white">
              {content.benefits.title}
            </h2>
            {content.benefits.subtitle && (
              <p className="text-xl text-gray-400">
                {content.benefits.subtitle}
              </p>
            )}
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
            {content.benefits.items?.map((benefit) => (
              <div key={benefit.id} className="bg-slate-800 p-6 rounded-xl border border-slate-700">
                <div className={`text-5xl font-bold ${colorMap[benefit.id] || 'text-white'} mb-2`}>
                  {benefit.icon}
                </div>
                <div className="text-lg font-semibold text-white mb-2">{benefit.title}</div>
                <div className="text-gray-400 text-sm">{benefit.description}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};